<script lang="ts">
  import { onMount } from 'svelte'
  import { CircleCheck } from 'lucide-svelte'

  let {
    completed,
    hasSignup,
    joinUrl,
    patchUrl,
    csrfToken,
  }: {
    completed: boolean
    hasSignup: boolean
    joinUrl: string
    patchUrl: string
    csrfToken: string
  } = $props()

  let reachedEnd = $state(false)

  onMount(() => {
    const lastParagraph = document.getElementById('readings')?.querySelector(':scope > p:last-of-type')
    if (!lastParagraph) return reachedEnd = true;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          reachedEnd = true
          observer.disconnect()
        }
      },
      { threshold: 0 }
    )

    observer.observe(lastParagraph)

    return () => observer.disconnect()
  })
</script>

<div id="day-footer" class="fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur border-t border-gray-200">
  <div class="mx-auto max-w-xl px-4 py-3 flex justify-center">
    {#if completed}
      <div class="inline-flex justify-center items-center gap-2 px-6 py-3 w-full max-w-sm rounded-lg bg-emerald-700 text-emerald-50 font-medium">
        <CircleCheck class="w-5 h-5" />
        <span class="pr-2">Completed</span>
      </div>
    {:else if hasSignup}
      {#if reachedEnd}
        <form method="post" action={patchUrl} class="w-full">
          <input type="hidden" name="_method" value="patch">
          <input type="hidden" name="authenticity_token" value={csrfToken}>
          <input type="hidden" name="complete" value="true">
          <button
            type="submit"
            class="px-6 py-3 w-full max-w-sm rounded-lg bg-blue-900 text-white font-medium hover:bg-blue-800 transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-900"
          >
            Mark completed
          </button>
        </form>
      {:else}
        <div class="px-6 py-3 w-full max-w-sm rounded-lg bg-blue-900 text-white font-medium opacity-60 cursor-default">
          Keep reading...
        </div>
      {/if}
    {:else}
      <a
        href={joinUrl}
        class="px-6 py-3 w-full max-w-sm rounded-lg bg-blue-900 text-white font-medium hover:bg-blue-800 transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-900"
      >
        Join the challenge
      </a>
    {/if}
  </div>
</div>
